import { getLegacyBridge } from "./state";

export const OPTIMIZATION_PRESETS = {
  none: "",
  portrait_realistic: "Ưu tiên vẻ chân thực của ảnh chân dung: kết cấu da tự nhiên, sợi tóc riêng lẻ và tóc con, tóc có nhiều lớp và độ bóng tự nhiên, ánh sáng định hướng mềm, bóng đổ tự nhiên ở cổ và vai, độ sâu trường ảnh chân thực, chi tiết vải và nếp áo rõ ràng, ánh sáng bắt mắt trong mắt, giữ tỷ lệ khuôn mặt tự nhiên.",
  product: "Ưu tiên ảnh sản phẩm thương mại: vật liệu và bề mặt rõ ràng, cạnh sản phẩm sạch, tỷ lệ chính xác, bóng đổ tiếp xúc tự nhiên, ánh sáng studio, tách chủ thể khỏi nền, chi tiết nhỏ sắc nét.",
  fashion: "Ưu tiên thời trang biên tập: chất liệu vải, đường may, nếp gấp, độ rủ, ánh sáng viền, dáng người tự nhiên, bố cục và ánh sáng kiểu editorial.",
  creative: "Ưu tiên tính sáng tạo và thẩm mỹ: bảng màu có chủ đích, bố cục nổi bật, chiều sâu không gian, tương phản rõ, chi tiết phong cách nhất quán, vẫn giữ đúng nội dung chính trong prompt.",
} as const;

export type OptimizationStyle = keyof typeof OPTIMIZATION_PRESETS;

export function normalizeOptimizationStyle(value: unknown): OptimizationStyle {
  const style = String(value || "none") as OptimizationStyle;
  return Object.prototype.hasOwnProperty.call(OPTIMIZATION_PRESETS, style) ? style : "none";
}

export function optimizationInstruction(value: unknown): string {
  return OPTIMIZATION_PRESETS[normalizeOptimizationStyle(value)];
}

export function appendOptimizationInstruction(prompt: string, value: unknown): string {
  const instruction = optimizationInstruction(value);
  return instruction ? `${prompt.trimEnd()}\n\nChỉ dẫn tối ưu hình ảnh: ${instruction}` : prompt;
}

export function currentOptimizationStyle(): OptimizationStyle {
  const select = getLegacyBridge().els.optimizationStyle;
  return normalizeOptimizationStyle(select?.value);
}

export function initOptimizationPresetsFeature(): void {
  const { els } = getLegacyBridge();
  els.optimizationStyle?.addEventListener("change", () => {
    getLegacyBridge().methods.updateRequestPreview?.();
  });
  if (els.optimizationStyle) els.optimizationStyle.value = "none";
}
